module.exports = __webpack_public_path__ + "static/media/Pakistan.0a1ea397.png";